import React from 'react';
import { isMiracleEar } from '../../../hooks/miracle-ear-hook';
import { ISession } from '../../../models/pro-sites';
import './service-request.css';
import { US } from '../../common/constants';
import { openServiceRequestInstructions } from '../../../models/service-request';

interface IServiceRequestSidebarProps {
    session: ISession | null;
}
const ServiceRequestSidebar = ({ session }: IServiceRequestSidebarProps) => {
    return (
        <>
            {session!.country === US && !isMiracleEar(session!.siteNumber) && (
                <div>
                    <div className="gutter-bottom">
                        <h3
                            className="service-request-h3"
                            style={{ marginTop: '20px' }}
                        >
                            Return & Exchange Policy
                        </h3>
                        <p>
                            For information on the Return & Exchange Policy,
                            <a href="/my-account/return-exchange-policy">
                                &nbsp;click here
                            </a>
                            .
                        </p>
                    </div>
                    <h3 className="service-request-h3">Contact Us</h3>
                    <p>
                        Have questions? Call your Worry Free Warranty
                        Representative today at
                        <strong>&nbsp;1-800-328-8602&nbsp;</strong>
                        or
                        <a href="mailto:starkeysupport@starkey.com">
                            &nbsp;send us an email&nbsp;
                        </a>
                        with your question or concern.
                    </p>
                    <dt>Related Materials</dt>
                    <dd className="alt">
                        <a
                            target="_blank"
                            href="#"
                            onClick={(e) => openServiceRequestInstructions(e)}
                        >
                            <div>Service Request Instructions</div>
                        </a>
                    </dd>
                </div>
            )}
        </>
    );
};

export default ServiceRequestSidebar;
